<script>
  import RedirectPage from "./RedirectPage.svelte";

  import SideNav from "./components/SideNav.svelte";

  import { Router, Route, NotFound, redirect } from "./pager";
  import { apiServer } from "./config.js";
  import { session } from "./components/js/store.js";
  import AXHR from "./components/js/axhr.js";
  import { fade } from "svelte/transition";

  import pwaInstallHandler from "pwa-install-handler";
  let modalInstall = false;
  pwaInstallHandler.addListener((canInstall) => {
    setTimeout(() => {
      if (localStorage.getItem("install")) {
      } else {
        modalInstall = canInstall;
      }
    }, 1500);
  });
  function hideModalInstall() {
    localStorage.setItem("install", true);
    modalInstall = false;
  }
  import SOffline from "s-offline";
  const handleNetworkChange = ({ detail }) => {};

  import Error404 from "./pages/Error404.svelte";
  import Background from "./components/Background.svelte";
  import Footer from "./components/Footer.svelte";
  import Alert from "./components/Alert.svelte";
  import Login from "./pages/Login.svelte";
  import Daftar from "./pages/Daftar.svelte";
  import Aktivasi from "./pages/Aktivasi.svelte";
  import Forget from "./pages/Forget.svelte";
  import ForgetVerify from "./pages/ForgetVerify.svelte";
  import Dashboard from "./pages/Dashboard.svelte";
  import Akun from "./pages/Akun.svelte";
  import HotspotUsers from "./pages/HotspotUsers.svelte";
  import HotspotProfiles from "./pages/HotspotProfiles.svelte";
  import Splash from "./pages/Splash.svelte";
  import Rboard from "./pages/Rboard.svelte";
  import HotspotActive from "./pages/HotspotActive.svelte";
  import HotspotHost from "./pages/HotspotHost.svelte";
  import HotspotCookies from "./pages/HotspotCookies.svelte";
  import HotspotBinding from "./pages/HotspotBinding.svelte";
  import HotspotGenerateUsers from "./pages/HotspotGenerateUsers.svelte";
  import Points from "./pages/Points.svelte";
  import HotspotUsersPrint from "./pages/HotspotUsersPrint.svelte";
  import UpdatePass from "./pages/UpdatePass.svelte";
  import UpdateProfile from "./pages/UpdateProfile.svelte";

  let loadingLine = false;
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  let _token = localStorage.getItem("t");
  _token = JSON.parse(_token);

  //alert
  let alert = [];

  //alert - welcome
  if (!sessionStorage["welcome_message"]) {
    alert = [
      ...alert,
      {
        message: "Hello, welcome, have a nice day ...",
        color: "green",
      },
    ];
    setTimeout(() => {
      alert = [];
    }, 5000);
  }
  sessionStorage["welcome_message"] = false;

  function refreshToken(params) {
    var config = {
      method: "post",
      url: apiServer + "/accounts/refresh-token",
    };

    AXHR(config)
      .then(function (response) {
        let current = localStorage.getItem("t");

        let sessionData = {
          api: apiServer,
          token: current.jwtToken,
          loggedin: true,
          user: current,
          routers: sessions.routers,
          routeractive: sessions.routeractive,
          notifications: { invoice: 0, info: 0 },
        };
        session.update((n) => sessionData);

        localStorage.setItem("t", JSON.stringify(response.data));
        location.reload();
      })
      .catch(function (error) {
        tokenExpired = false;
        localStorage.removeItem("t");
        redirect("/login");
        console.log(error);
      });
  }
  let tokenExpired = false;
  const guard = (ctx, next) => {
    loadingLine = true;
    let _token = localStorage.getItem("t");
    _token = JSON.parse(_token);

    if (_token) {
      var config = {
        method: "get",
        url: apiServer + "/accounts/" + _token.id,
        headers: {
          Authorization: "Bearer " + _token.jwtToken,
        },
      };

      AXHR(config)
        .then(function (response) {
          let sessionData = {
            api: apiServer,
            token: _token.jwtToken,
            loggedin: true,
            user: response.data,
            routers: sessions.routers,
            routeractive: sessions.routeractive,
            notifications: { invoice: 0, info: 0 },
          };
          session.update((n) => sessionData);
          loadingLine = false;
          if (sessions.routeractive === undefined) {
            if (_token) {
              var config = {
                method: "get",
                url: apiServer + "/rb",
                headers: {
                  Authorization: "Bearer " + _token.jwtToken,
                },
              };
              AXHR(config).then(function (response) {
                tokenExpired = false;
                let routeractive;
                let serverSelected = localStorage.getItem("_server_location");
                if (sessions.routeractive) {
                  if (serverSelected) {
                    if (response.data[serverSelected]) {
                      routeractive = response.data[serverSelected];
                    } else {
                      routeractive = response.data[0];
                      localStorage.setItem("_server_location", 0);
                    }
                  } else {
                    if (sessions.routeractive.name === response.data[0].name) {
                      routeractive = sessions.routeractive;
                    } else {
                      routeractive = response.data[0];
                    }
                  }
                } else {
                  if (serverSelected) {
                    if (response.data[serverSelected]) {
                      routeractive = response.data[serverSelected];
                    } else {
                      routeractive = response.data[0];
                      localStorage.setItem("_server_location", 0);
                    }
                  } else {
                    console.log(response.data);
                    routeractive = response.data[0];
                  }
                }
                let sessionData = {
                  api: apiServer,
                  token: _token.jwtToken,
                  loggedin: true,
                  user: sessions.user,
                  routers: response.data,
                  routeractive: routeractive,
                  notifications: { invoice: 0, info: 0 },
                };
                session.update((n) => sessionData);
                if (response.data.length > 0) {
                  next();
                } else {
                  redirect("/server");
                }
              });
            }
          } else {
            next();
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 401) {
              tokenExpired = true;
              loadingLine = false;
            }
          } else {
            redirect("/splash");
          }
        });
    } else {
      redirect("/splash");
      loadingLine = false;
    }
  };

  const guardServer = (ctx, next) => {
    loadingLine = true;
    let _token = localStorage.getItem("t");
    _token = JSON.parse(_token);

    if (_token) {
      var config = {
        method: "get",
        url: apiServer + "/accounts/" + _token.id,
        headers: {
          Authorization: "Bearer " + _token.jwtToken,
        },
      };

      AXHR(config)
        .then(function (response) {
          tokenExpired = false;
          let sessionData = {
            api: apiServer,
            token: _token.jwtToken,
            loggedin: true,
            user: response.data,
            routers: sessions.routers,
            routeractive: sessions.routeractive,
            notifications: { invoice: 0, info: 0 },
          };
          session.update((n) => sessionData);
          loadingLine = false;
          next();
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 401) {
              tokenExpired = true;
              loadingLine = false;
            }
          } else {
            redirect("/splash");
          }
        });
    } else {
      redirect("/splash");
      loadingLine = false;
    }
  };
</script>

{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<SOffline
  pingUrl="https://mikhub.netlify.app"
  on:detectedCondition={handleNetworkChange}
>
  <div slot="online" class="online">
    <span class="hidden">Anda Online</span>
  </div>
  <div slot="offline" class="offline">
    <div
      class="fixed top-0 left-0 right-0 z-30 flex items-center justify-center w-screen h-screen bg-red-700 bg-opacity-75"
    >
      <div
        id="modal-Offline"
        class="w-10/12 p-6 font-normal text-gray-700 bg-white border-2 border-yellow-400 rounded-lg shadow-lg lg:w-3/12"
        style="height: 200px;"
      >
        <h2 class="mb-2 text-xl">Kamu Offline..🤕</h2>
        <p class="my-4 text-sm">
          Cek koneksi data internet/wifi kamu, agar dapat terhubung kembali
          dengan Mikhub
        </p>
        <a
          href="./"
          on:click|preventDefault={() => window.location.reload()}
          id="ReloadConnection"
          style="display:inline-block;"
          class="w-full p-2 text-center text-yellow-800 bg-yellow-300 rounded-lg shadow-lg focus:bg-gray-200 focus:outline-none hover:bg-yellow-200"
          >Coba Lagi</a
        >
      </div>
    </div>
  </div>
</SOffline>

{#if tokenExpired}
  <div
    transition:fade={{ duration: 400 }}
    class="fixed top-0 z-20 flex items-center justify-center w-screen h-screen bg-gray-800 bg-opacity-75"
  >
    <div
      class="max-w-md mx-2 text-blue-600 bg-white rounded-lg shadow-xl shake"
    >
      <p class="p-5 mb-5 text-center">
        <b class="text-xl">Are you still here?</b><br />
        if yes, please click refresh. We're trying to keep you connected
      </p>

      <div class="flex justify-between">
        <a
          on:click|preventDefault={() => refreshToken()}
          href="/"
          class="block w-full px-5 py-2 text-center text-white bg-blue-500 rounded-bl-lg hover:bg-opacity-95"
          >Refresh</a
        >
        <a
          on:click|preventDefault={() => localStorage.removeItem("t")}
          on:click|preventDefault={() => location.reload()}
          href="/"
          class="block w-full px-5 py-2 text-center text-white bg-gray-500 rounded-br-lg hover:bg-opacity-95"
          >No</a
        >
      </div>
    </div>
  </div>
{/if}

{#if modalInstall}
  <div
    transition:fade={{ duration: 400 }}
    class="fixed top-0 left-0 right-0 z-10 flex items-center justify-center w-screen h-screen bg-gray-700 bg-opacity-75"
  >
    <div
      id="modal-install"
      class="w-10/12 p-6 font-normal text-gray-700 bg-white rounded-lg lg:w-3/12"
      style="height: 190px;"
    >
      <h2 class="mb-2 text-xl">Install Aja...</h2>
      <p class="my-4 text-sm">
        Install Mikhub gak perlu download, klik tombol pasang sekarang
      </p>
      <button
        id="installButton"
        style="display:inline-block;"
        on:click={() => pwaInstallHandler.install()}
        on:click={() => hideModalInstall()}
        class="w-full p-2 text-gray-800 bg-gray-300 rounded-lg shadow-lg focus:bg-gray-200 focus:outline-none hover:bg-gray-200"
        >Pasang Sekarang</button
      >
      <button
        on:click={() => hideModalInstall()}
        class="flex items-center justify-center w-6 h-6 p-2 mx-auto my-3 text-sm text-red-700 bg-gray-100 rounded-full shadow focus:outline-none"
        >x</button
      >
    </div>
  </div>
{/if}
<Background />
<Router>
  <Route path="/" middleware={[guard]}>
    <Dashboard />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/splash">
    <Splash />
  </Route>

  <Route path="/login">
    <Login />
  </Route>

  <Route path="/daftar">
    <Daftar />
  </Route>

  <Route path="/aktivasi">
    <Aktivasi />
  </Route>

  <Route path="/aktivasi/:token" let:params>
    <Aktivasi {params} />
  </Route>

  <Route path="/forget">
    <Forget />
  </Route>

  <Route path="/forget/verify">
    <ForgetVerify />
  </Route>
  <Route path="/forget/verify/:token" let:params>
    <ForgetVerify {params} />
  </Route>

  <Route path="/akun" middleware={[guardServer]}>
    <Akun />
    <Footer />
  </Route>
  <Route path="/points" middleware={[guardServer]}>
    <Points />
    <Footer />
  </Route>
  <Route path="/server" middleware={[guardServer]}>
    <Rboard />
    <Footer />
  </Route>
  <Route path="/go/:path" let:params middleware={[guardServer]}>
    <RedirectPage {params} />
  </Route>
  <Route path="/:rb/hotspot-user" let:params middleware={[guard]}>
    <HotspotUsers />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-user-print" let:params middleware={[guard]}>
    <HotspotUsersPrint />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-profile" let:params middleware={[guard]}>
    <HotspotProfiles />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-active" let:params middleware={[guard]}>
    <HotspotActive />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-host" let:params middleware={[guard]}>
    <HotspotHost />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-cookie" let:params middleware={[guard]}>
    <HotspotCookies />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-binding" let:params middleware={[guard]}>
    <HotspotBinding />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/:rb/hotspot-generate" let:params middleware={[guard]}>
    <HotspotGenerateUsers />
    <SideNav />
    <Footer />
  </Route>

  <Route path="/akun/password" middleware={[guardServer]}>
    <UpdatePass />
    <Footer />
  </Route>
  <Route path="/akun/profile" middleware={[guardServer]}>
    <UpdateProfile />
    <Footer />
  </Route>

  <NotFound>
    <Error404 />

    <Footer />
  </NotFound>
  {#if loadingLine}
    <div
      class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-300 animate-pulse"
    />
  {/if}
</Router>
